// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// local
// api
import Device from 'app/api/device';
// views
import CustomDropdown from 'app/ui/commons/CustomDropdown';
// libs
import { sortString } from 'app/lib/helper';

class DropdownDevices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            options: [],
        };
    }

    componentDidMount() {
        Device.list()
            .then(this.onLoadClientSuccess)
            .catch(this.onLoadClientFail);
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadClientSuccess = result => {
        const { patient } = this.props;
        const sameClientAsPatient = device => (patient ? patient.clientId === device.clientId : true);
        let devices = result.filter(d => (!d.patientId || d.id === this.props.value) && sameClientAsPatient(d)).map(device => ({
            key: device.key,
            text: device.key,
            value: device.id,
        }));
        devices.sort((a, b) => sortString(a.text, b.text));
        const options = [{ text: '-', value: null }].concat(devices);
        if (this._isMounted) {
            this.setState({
                loading: false,
                options,
            });
        }
    };

    onLoadClientFail = () => {
        if (this._isMounted) {
            this.setState({
                loading: false,
                options: [],
            });
        }
    };

    render() {
        const { options, loading } = this.state;
        const { width, onChange, value, error, label, placeholder } = this.props;
        return (
            <CustomDropdown
                placeholder={placeholder}
                label={label}
                selection
                width={width}
                loading={loading}
                options={options}
                value={value}
                onChange={onChange}
                error={error ? true : false}
            />
        );
    }
}

DropdownDevices.propTypes = {
    width: PropTypes.number.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func,
    patient: PropTypes.object,
    error: PropTypes.string,
    label: PropTypes.object,
    placeholder: PropTypes.string,
};

export default DropdownDevices;
